import React from 'react';
import QrCodeView from './QrCodeView';

function QrCodeDemoPage() {
    return (
        <div style={{width: 500, margin: '20px auto'}}>
            <QrCodeView
                title="这是人名"
                subTitle="这是 id这是 id这是 id"
                data="hello world this is a qrcode demo"
            />
        </div>
    );
}

export default QrCodeDemoPage;
